// @flow
import { SET_MESSAGES } from '../ui/ui.const.js';
import { removeMessageByKey } from '../ui/ui.actions.js';

const clearMessagesMiddleware = (store: Object) => (next: Function) => (action: Action) => {
  if (action.type === SET_MESSAGES && Object.keys(action.payload.messages).length) {
    action.payload.messages.forEach(message => {
      const timeout = message.timeout || 10000;
      if (message.timeout !== Infinity) {
        return setTimeout(() => store.dispatch(removeMessageByKey(message.key)), timeout);
      }
      return null;
    });
  }

  return next(action);
};

export default clearMessagesMiddleware;
